var gql = require("graphql-tag");

const ORDER_COUNTER_QUERY = gql`
    query SiteConfig {
        siteConfig {
            order_counter
        }
    }
`;

module.exports = ORDER_COUNTER_QUERY;
